import { useImmer } from "use-immer";
import { useEffect } from "react";
import UtilService from "../../service/UtilService";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesRight,
  faAnglesLeft,
  faAngleUp,
  faAngleDown
} from "@fortawesome/free-solid-svg-icons";

const LOCAL_STORAGE_NAME = "customerHistoryPatternDisplayedColumns";

const DEFAULT_DISPLAYED = [
  "companyId",
  "merchantCode",
  "tier",
  "dominantHour",
  "slotsValid",
  "relevance",
  //"lastUpdated"
];

// Column lastUpdated is now displayed at the bottom of the table
const HIDDEN_COLUMNS = ["lastUpdated"];

const CustomerHistoryPatternsColumnConfigurator = ({ sampleData, onChange }) => {
  const [displayed, updateDisplayed] = useImmer([]);
  const [displayable, updateDisplayable] = useImmer([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem(LOCAL_STORAGE_NAME));

    if (stored && Array.isArray(stored) && stored.length > 0) {
      updateDisplayed(stored);
    } else {
      updateDisplayed(DEFAULT_DISPLAYED);
      localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(DEFAULT_DISPLAYED));
    }
  }, []);

  useEffect(() => {
    if (!sampleData || sampleData.length === 0) return;
    if (displayable.length > 0) return;

    const allKeys = Object.keys(sampleData[0]);
    const remaining = allKeys
      .filter(k => !displayed.includes(k))
      .filter(k => !HIDDEN_COLUMNS.includes(k));

    updateDisplayable(remaining);
  }, [sampleData]);

  useEffect(() => {
    if (displayed.length > 0) {
      onChange(displayed);
      localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(displayed));
    }
  }, [displayed]);

  const moveRight = (idx) => {
    const attr = displayable[idx];
    updateDisplayed([...displayed, attr]);
    updateDisplayable(displayable.filter((_, i) => i !== idx));
  };

  const moveLeft = (idx) => {
    const attr = displayed[idx];
    updateDisplayable([...displayable, attr].sort());
    updateDisplayed(displayed.filter((_, i) => i !== idx));
  };

  const moveUp = (idx) => {
    if (idx === 0) return;
    updateDisplayed((draft) => {
      [draft[idx - 1], draft[idx]] = [draft[idx], draft[idx - 1]];
    });
  };

  const moveDown = (idx) => {
    if (idx >= displayed.length - 1) return;
    updateDisplayed((draft) => {
      [draft[idx + 1], draft[idx]] = [draft[idx], draft[idx + 1]];
    });
  };

  const maxRows = Math.max(displayable.length, displayed.length);

  return (
    <table className="config-table">
      <thead>
      <tr>
        <th>Displayable attributes</th>
        <th>Displayed attributes</th>
      </tr>
      </thead>

      <tbody>
      {Array.from({ length: maxRows }).map((_, idx) => (
        <tr className="trnohover" key={idx}>

          {/* Displayable */}
          <td>
            {displayable[idx] && (
              <>
                {UtilService.camelCaseToReadable(displayable[idx])}
                <span className="float-right">
                    <FontAwesomeIcon
                      icon={faAnglesRight}
                      className="icon-clickable"
                      onClick={() => moveRight(idx)}
                    />
                  </span>
              </>
            )}
          </td>

          {/* Displayed */}
          <td>
            {displayed[idx] && (
              <>
                {UtilService.camelCaseToReadable(displayed[idx])}
                <span className="float-right">
                    <FontAwesomeIcon
                      icon={faAnglesLeft}
                      className="icon-clickable"
                      onClick={() => moveLeft(idx)}
                    />
                  &nbsp;&nbsp;
                  <FontAwesomeIcon
                    icon={faAngleUp}
                    className="icon-clickable"
                    onClick={() => moveUp(idx)}
                  />
                  &nbsp;&nbsp;
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className="icon-clickable"
                    onClick={() => moveDown(idx)}
                  />
                  </span>
              </>
            )}
          </td>

        </tr>
      ))}
      </tbody>
    </table>
  );
};

export default CustomerHistoryPatternsColumnConfigurator;
